import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore'

// collection is an array of objects with id properties
// member is an object with an id property
// We'll add member if an object with same ID is not already present,
// or update the matching object if one is present.
function upsertArray(collection, member) {
  const idx = collection.findIndex((obj) => obj.id === member.id)
  if (idx !== -1) {
    collection.splice(idx, 1, member)
  } else {
    collection.push(member)
  }
}

export const useClassifierStore = defineStore('ClassifierStore', {
  state: () => modelCollectionState('classifiers'),
  getters: { ...modelCollectionGetters('classifiers') },
  actions: {
    ...modelCollectionActions('classifiers'),
    // Create a new member in the collection on the server and add it to the collection
    async createClassifierValue(classifierValue) {
      return this.api.createClassifierValue(classifierValue).then((response) => {
        upsertArray(
          this.getClassifier(classifierValue.classifier_id).values,
          response.data.classifier_value,
        )
      })
    },
    async updateClassifierValue(classifierValue) {
      return this.api.updateClassifierValue(classifierValue).then((response) => {
        upsertArray(
          this.getClassifier(classifierValue.classifier_id).values,
          response.data.classifier_value,
        )
      })
    },
    // Delete a member in the collection on the server and remove it from the collection
    async deleteClassifierValue(classifierValue) {
      return this.api.deleteClassifierValue(classifierValue).then(() => {
        const currentValues = this.getClassifier(classifierValue.classifier_id).values
        const idx = currentValues.findIndex((val) => val.id === classifierValue.id)
        if (idx !== -1) currentValues.splice(idx, 1)
      })
    },
  },
})
